import React, { memo } from 'react';
import { string } from 'prop-types';

const IconColor = memo(({ color }) => <div key={color} className={`icon-color-${color}`} />);

IconColor.propTypes = {
  color: string,
};

IconColor.displayName = 'IconColor';

export default IconColor;
